'use strict'

import _ from 'lodash'
import {Organization} from 'janux-people'
import configMock from './mock-data/config'

configMock.company = Organization.fromJSON(configMock.company)

const mockMode = process.env.MOCKMODE

const appNavPaths = {
	login:  'connect',
	logout: 'disconnect',
	admin:  'admin',
	myAccount:  'my-account',
	newProject: 'project/new',
	myProjects: 'project/list',
	activeProject: 'active-project'
}

const wwwNavPaths = {
	logo: '',
	faq:  'faq',
	prices:    'prices',
	services:  'services',
	resources: 'resources',
	contactUs: 'contact-us',
	doItYourself: 'do-it-yourself',
	fullService:  'full-service',
	resourceLinks:'resource-links',
	complianceWizard:  'compliance-wizard',
	costEstimator:  'compliance-wizard',
	termsAndConditions:'terms-and-conditions'
}

// TODO: Company and contact info is already stored in the db, editable
// through the admin section, and could be exposed via the config ofbject
// herewith - supportPhone2 would need to be added
const wwwContactInfo = {
	customerMail: 'customer.service@easytitle24.com',
	supportPhone1: '(415) 259-4068',
	supportPhone2: '(925) 671-4789'
}

export function configService (instance) {
	const http = instance.http

	// Can be used to denote the context/app in which this service is being used
	const APP = 'app'
	const SITE = 'site'

	const service = {
		get APP () { return APP },
		get SITE () { return SITE },

		/**
		 * Just load config
		 * @returns full stored config
		 */
		loadConfig: async function (context) {
			if (!mockMode) {
				return http.jsonrpc(
					'/rpc/public/config',
					'load',
					[]
				).then(function (resp) {
					let out = resp.result
					out.company = Organization.fromJSON(out.company)

					// the baseUrls of the app/site are sent via the config object so that
					// the same deployment package can be shared between QA and PROD
					if (context === APP) {
						out.navLinks = _.merge(
							_.mapValues(appNavPaths, path => '/' + path),
							_.mapValues(wwwNavPaths, path => out.baseUrl.www + '/' + path),
							wwwContactInfo // TODO: Expunge in due time - see comment at top
						)
					} else if (context === SITE) {
						out.navLinks = _.merge(
							_.mapValues(appNavPaths, path => out.baseUrl.app + '/' + path),
							_.mapValues(wwwNavPaths, path => '/' + path),
							wwwContactInfo // TODO: Expunge in due time - see comment at top
						)
					} else {
						console.error('configService.loadConfig called with invalid context:', context)
					}

					console.debug('configured navLinks:', out.navLinks)

					return out
				})
			} else {
				return configMock
			}
		},

		/**
		 * Load and store config in local
		 * @returns full stored config
		 */
		load: async function (context) {
			const config = await service.loadConfig(context)
			// Store config in local so we can access it at any point
			// TODO: Probably we should use a vuex state for this?
			instance.prototype.$e24Common.storageService.setItem('config', config, true)
			instance.prototype.$e24Common.storageService.setItem('navLinks', config.navLinks, true)
			instance.prototype.$e24Common.storageService.setItem('isStagingEnv', config.isStagingEnv, true)
			return config
		},

		/**
		 * @returns estimator prices only
		 */
		loadEstimatorPrices: async function () {
			if (!mockMode) {
				return http.jsonrpc(
					'/rpc/public/config',
					'loadEstimatorPrices',
					[]
				).then(function (resp) {
					return resp.result
				})
			} else {
				return configMock.estimator
			}
		},

		/**
		 * @returns company data only (janux-people organization)
		 */
		loadCompany: async function () {
			if (!mockMode) {
				return http.jsonrpc(
					'/rpc/public/config',
					'loadCompany',
					[]
				).then(function (resp) {
					let out = resp.result
					out = Organization.fromJSON(out)
					return out
				})
			} else {
				return configMock.company
			}
		},

		/**
		 * @param config The configuration object
		 * @returns update object response
		 */
		update: function (config) {
			let configToStore = _.clone(config)
			configToStore.company = configToStore.company.toJSON()

			return http.jsonrpc(
				'/rpc/2.0/config',
				'update',
				[ config ]
			).then(function (resp) {
				let out = resp.result
				return out
			})
		}
	}

	return service
}



// WEBPACK FOOTER //
// /var/tomcat/.jenkins/workspace/EasyTitle24/easytitle24-2.x-common/services/config-service.js